/* eslint-disable @next/next/no-img-element */
"use client";

import { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
// import { useHeroSection } from "@/hooks/useHeroSection";
import Navbar from "@/shared/Navbar";
import BridgeLoanPage from "./BridgeLoanPage.tsx/BridgeLoan";
import { usePages } from "@/hooks/usePages";

const BuyBeforeYouSellPage = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const { data: pages, loading } = usePages();

  //  Combine static + dynamic dropdown items
  const howToHubDropdown = useMemo(() => {
    const staticItems = [
      {
        label: "Property Intelligence Report",
        href: "/how-to-hub/property-intelligence-report",
      },
      { label: "Mortgage Guide", href: "/how-to-hub/mortgage-guide" },
    ];

    const dynamicItems =
      pages?.map((p) => ({
        label: p.title || "Untitled",
        href: `/how-to-hub/${p.slug}`,
      })) || [];

    // Merge both (dynamic first, static at bottom)
    return [
      ...(dynamicItems.length
        ? dynamicItems
        : loading
        ? [{ label: "Loading...", href: "#" }]
        : [{ label: "No Pages Found", href: "#" }]),
      ...staticItems,
    ];
  }, [pages, loading]);

  // const HeroSectionBuyBeforeYousell = useHeroSection({
  //   title: "Track Your Home’s True Value Instantly",
  //   subtitle:
  //     "Join a platform built for professionals who care connect with motivated clients, showcase your expertise, and manage the process with ease.",
  //   buttonText: "Track My Home Value",

  //   //  anchor link
  //   buttonLink: "#home-value-section",

  //   backgroundImage: "/buy-before-you-sell/man.png",
  // });

  //  Preload iframe connection
  useEffect(() => {
    const preloadIframe = document.createElement("link");
    preloadIframe.rel = "preconnect";
    preloadIframe.href = "https://homequityreport.com";
    document.head.appendChild(preloadIframe);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/*  Navbar with dynamic + static How-To Hub dropdown */}
      <Navbar
        defaultLogo="/logo/asklocal-white-logo.png"
        scrolledLogo="/logo/color-full-logo.png"
        isLight
        labelColor="#ffffff"
        labelHoverColor="#EB9C2C"
        buttonBg="#EB9C2C"
        buttonTextColor="#FFFFFF"
        buttonHoverBg="#4177BC"
        buttonHoverText="#ffffff"
        ctaText="Looking to Buy/Sell?"
        ctaLink="/buy-sell"
        navItems={[
          { label: "Home", href: "/" },
          {
            label: "Property Reports",
            href: "/how-to-hub/property-intelligence-report",
          },
           {
              label: "Search for Homes",
              href: "https://www.asklocalhomes.com/",
            },
          {
            label: "How-To-Hub",
            dropdown: howToHubDropdown, // dynamically combined
          },
        
          { label: "Pro-finder", href: "/pro-finder" },
        ]}
      />

      {/* {HeroSectionBuyBeforeYousell} */}

      <section>
<section className="relative w-full min-h-[90vh] flex items-center overflow-hidden">

  {/* Background */}
<div className="absolute inset-0 bg-[#9CA9BA] z-0" />

  {/* Desktop image ONLY */}
  <div className="absolute top-0 right-0 h-full w-full md:w-[65%] z-0 hidden md:block">
    <img
      src="/askLocal-digital-mortgage-coach/HomeIq.png"
      alt="Home IQ"
      className="w-full h-full object-cover object-center md:object-left"
    />
  </div>

<div
  className="absolute top-0 left-0 h-full w-full md:w-[70%] z-10 hidden md:block"
  style={{
    background:
      "linear-gradient(to right, #9E9DA0 40%, #9E9DA0 55%, rgba(158,157,160,0.75) 65%, rgba(158,157,160,0.35) 75%, transparent 90%)",
  }}
/>
<div
  className="absolute top-0 right-0 h-full w-full md:w-[30%] z-10"
  style={{
    background:
      "linear-gradient(to left, rgba(120,120,125,0.25) 0%, transparent 100%)",
  }}
/>
  {/* CONTENT (THIS IS THE ONLY FIX) */}
  <div className="relative z-20 w-full flex flex-col md:flex-row items-center justify-between px-6 sm:px-10 lg:px-24 py-16 gap-10">

    {/* TEXT */}
    <div className="flex flex-col gap-5 max-w-[720px] text-center md:text-left">

      <h1
        className="text-white  judson-regular "
        style={{ fontSize: "clamp(36px, 6vw, 78px)" }}
      >
        Track Your Home&apos;s<br />True Value Instantly
      </h1>

      <p className="text-white/90 text-base inter-medium sm:text-lg ">
        Join a platform built for professionals who care. Connect with
        motivated clients, showcase your expertise, and manage the process
        with ease.
      </p>

      <div className="flex flex-col sm:flex-row items-center md:items-start gap-4 sm:gap-5 mt-2">

        <button className="text-white text-sm inter-semibold pt-2.5 underline underline-offset-4 hover:text-white/75 transition-colors">
          Download Full CMA Report
        </button>

        <button className="bg-[#EB9C2C] hover:bg-white hover:text-black inter-semibold text-white text-sm font-semibold px-6 py-3 rounded-md transition-all shadow-md w-full sm:w-auto">
          Connect with Local Pro
        </button>

      </div>
    </div>

    {/* IMAGE (NOW SAFE — NO MOBILE BREAK) */}
    <div className="w-full md:w-[65%] flex lg:hidden justify-center md:justify-end z-10">

      <img
        src="/askLocal-digital-mortgage-coach/HomeIq.png"
        alt="Home IQ"
        className="w-full h-auto rounded-xl md:h-full object-cover object-center"
      />

    </div>

  </div>
</section>
      </section>

      {/*  MAIN SECTION */}

      <section id="home-value-section">
        <section className="flex flex-col items-center text-center py-16 px-4 bg-linear-to-b from-white via-[#F9FAFB] to-[#EFF3F8]">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-5xl inter-semibold text-[#1E293B]"
          >
            Track Your Home’s True Value Instantly
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-gray-600 max-w-2xl mt-3 text-sm md:text-base leading-relaxed"
          >
            Discover how your property’s wealth grows over time. Get real-time
            insights powered by{" "}
            <span className="font-semibold text-[#4177BC]">HomeIQ</span> — your
            smart home equity dashboard.
          </motion.p>

          <div className="relative w-full max-w-5xl mt-10 bg-white shadow-2xl border border-gray-100 rounded-2xl p-4 md:p-6 overflow-hidden">
            {!iframeLoaded && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="absolute inset-0 flex items-center justify-center bg-linear-to-br from-gray-50 via-gray-100 to-gray-200 rounded-2xl"
              >
                <div className="h-12 w-12 border-4 border-[#4177BC] border-t-transparent rounded-full animate-spin"></div>
                <p className="ml-4 text-gray-600 text-sm font-medium">
                  Loading HomeIQ Insights...
                </p>
              </motion.div>
            )}

            <motion.iframe
             src="https://homequityreport.com/widget/?user=brad_binder&wealth=true&hex=2681ff" 
              onLoad={() => setIframeLoaded(true)}
              name="myhomeiq"
              scrolling="no"
              frameBorder="0"
              allowFullScreen
              className="w-full rounded-xl"
              style={{
                height: "420px",
                border: "0px",
                transition: "opacity 0.5s ease",
                opacity: iframeLoaded ? 1 : 0,
              }}
            />
          </div>
        </section>
        {/* testing  */}
      </section>

      <div>
        <BridgeLoanPage />
      </div>
    </div>
  );
};

export default BuyBeforeYouSellPage;
